<div class="container-fluid">
    <div class="row">
        <div class="col-12 no-padding home-banner">
            <!--<picture class="home-banner-bg">
                <source srcset="../assets/site-theme/OldFaithfulVectorBG.svg">
                <img class="bg-scale" src="../assets/site-theme/OldFaithfulVectorBG.svg" alt="Forest with Old Faithful Geyser">
            </picture>-->
            <div class="row content-left-and-right">
                <div class="col-sm-7">
                    <!--<div class="home-banner-text text-center">
                        THE NAME YOU TRUST<br>FOR TIMELESS PLUMBING
                        <a class="a-nostyle" href="tel:15875681541">
                            <picture class="ribbon-image">
                                <source srcset="../assets/site-theme/OldFaithfulRibbon.svg">
                                <img src="../assets/site-theme/OldFaithfulRibbon.svg" alt="Red Ribbon with Purple Outline">
                                <div class="ribbon-text">CALL US 587-568-1541</div>
                            </picture>
                        </a>
                    </div>-->
                    <div class="home-banner-container">
                        <div class="row">
                            <div class="col-12 home-banner-text text-center">
                                THE NAME YOU TRUST<br>FOR TIMELESS PLUMBING
                            </div>
                        </div>
                        <div class="row ribbon-pt">
                            <div class="col-12 ribbon-image">
                                <a class="a-nostyle" href="tel:5875681541">
                                    <img src="../assets/site-theme/OldFaithfulRibbon.svg" alt="Red Ribbon with Purple Outline">
                                    <div class="ribbon-text">CALL US 587-568-1541</div>
                                </a> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 content-right">
                    <picture class="home-banner-bear">
                        <source srcset="../assets/site-theme/OldFaithfulBear.png">
                        <img class="pic-scale" src="../assets/site-theme/OldFaithfulBear.png" alt="Old Faithful Plumbing's Bear">
                    </picture>                  
                </div>
            </div> 
        </div>
    </div>
</div>

<div class="container-fluid bg-beige">
    <div class="retro-thin mb-3"></div>
    <div class="retro-thick"></div>
</div>

<div class="container-fluid bg-beige services-banner banner-padding pt-3 pb-3">
    <h1>SERVICES</h1>
    <div class="row">
        <div class="col-lg-3 col-md-6 d-flex justify-content-center text-center">
            <div class="service-card">
                <h2>Plumbing Reno &amp;<br>Remodeling</h2>
                <picture>
                    <source srcset="../assets/site-theme/PlumbReno.svg">
                    <img class="service-icon" src="../assets/site-theme/PlumbReno.svg" alt="Plunger and Wrench Icon">
                </picture>
                <p>We specialize in updating and optimizing your home's plumbing, ensuring efficiency and functionality with expert installation and redesign services.
                    <br><a routerLink="/services" href="/services">Read more.</a>
                </p>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 d-flex justify-content-center text-center mb-pt">
            <div class="service-card">
                <h2>Drain<br>Cleaning</h2>
                <picture>
                    <source srcset="../assets/site-theme/PipeClean.svg">
                    <img class="service-icon" src="../assets/site-theme/PipeClean.svg" alt="Clean Pipe Icon">
                </picture>
                <p>Our expert drain cleaning services eliminate clogs and buildup, ensuring your plumbing runs smoothly.
                    <br><a routerLink="/services" href="/services">Read more.</a>
                </p>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 d-flex justify-content-center text-center mb-tablet-pt mb-pt">
            <div class="service-card">
                <h2>Leak<br>Repair</h2>
                <picture>
                    <source srcset="../assets/site-theme/LeakRepair.svg">
                    <img class="service-icon" src="../assets/site-theme/LeakRepair.svg" alt="Leaking Faucet Icon">
                </picture>
                <p>We provide fast, reliable leak repair services to quickly fix plumbing issues, ensuring your system is restored.
                    <br><a routerLink="/services" href="/services">Read more.</a>
                </p>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 d-flex justify-content-center text-center mb-tablet-pt mb-pt">
            <div class="service-card">
                <h2>Hot Water Tank<br>Replacement</h2>
                <picture>
                    <source srcset="../assets/site-theme/HotWaterTank.svg">
                    <img class="service-icon" src="../assets/site-theme/HotWaterTank.svg" alt="Hot Water Tank Icon">
                </picture>
                <p>Our team provides professional hot water tank replacements, delivering efficient, reliable hot water with expert installation.
                    <br><a routerLink="/services" href="/services">Read more.</a>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid bg-beige pt-3">
    <div class="retro-thick mb-3"></div>
    <div class="retro-thin"></div>
</div>

<div class="container-fluid bg-beige">
    <a routerLink="/contact" href="/contact">
        <button type="button" class="btn-lg-red text-center">
            <p>Contact us for a FREE CONSULTATION today</p>
        </button>
    </a>
</div>

<div class="container-fluid bg-beige pb-5">
    <div class="retro-thin mb-3"></div>
    <div class="retro-thick"></div>
</div>

<div class="container-fluid bg-beige choose-us-banner">
    <div class="row banner-padding pt-3 pb-3">
        <div class="col-12">
            <h1 class="h1-shadow">CHOOSE US</h1>
            <!--<picture>
                <source srcset="../assets/site-theme/LivingRoomHappyFamily.jpg">
                <img class="bg-scale" src="../assets/site-theme/LivingRoomHappyFamily.jpg" alt="A young happy family playing and laughing in living room.">
            </picture>-->
            <div class="row opaque-boxes pb-5">
                <div class="col-md-4 d-flex justify-content-center">
                    <div class="opaque-box">
                        <div class="number-bullet">1</div>
                        <p>Experienced &amp; Licensed</p>
                    </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center mb-pt">
                    <div class="opaque-box">
                        <span class="number-bullet">2</span>
                        <p>Competative Pricing</p>
                    </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center mb-pt">
                    <div class="opaque-box">
                        <span class="number-bullet">3</span>
                        <p>Exceptional Customer Service</p>
                    </div>
                </div>
            </div>
            <div class="row opaque-boxes">
                <div class="col-md-6 d-flex justify-content-end justify-content-mobile left-content">
                    <div class="opaque-box">
                        <span class="number-bullet">4</span>
                        <p>Honest &amp; Transparent Communication</p>
                    </div>
                </div>
                <div class="col-md-6 d-flex justify-content-left justify-content-mobile mb-pt right-content">
                    <div class="opaque-box">
                        <span class="number-bullet">5</span>
                        <p>Clean &amp; Respectful Service</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid bg-beige pt-5">
    <div class="retro-thick mb-3"></div>
    <div class="retro-thin"></div>
</div>

<div class="container-fluid bg-beige text-center banner-padding pt-4 pb-4">
    <h2 class="pb-5">DEDICATED TO EXCELLENCE AND SERVICE</h2>
    <h1 class="pt-5 pb-5">ABOUT US</h1>
    <p class="pt-5">At Old Faithful Plumbing, we're a trusted, family-owned plumbing company with over 18 years of experience. We're committed to providing reliable, high-quality plumbing services with a personal touch. We pride ourselves on honesty, transparency, and building lasting relationships with our customers.</p>
</div>

<div class="container-fluid bg-beige pb-5">
    <div class="retro-thin mb-3"></div>
    <div class="retro-thick"></div>
</div>

<div class="container-fluid bg-beige pt-5 pb-5 mb-for-footer">
    <div class="row">
        <div class="col-sm-12 d-flex justify-content-center">
            <div class="praise-box">
                <picture>
                    <source srcset="../assets/site-theme/LeftQuote.svg">
                    <img class="service-icon text-image" src="..assets/site-theme/LeftQuote.svg" alt="Left Quote Mark">
                </picture>

                <!--Carousel-->
                <div id="myCarousel" class="carousel slide" data-ride="carousel">
                    <!-- Carousel indicators -->
                    <ol class="carousel-indicators">
                        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                        <li data-target="#myCarousel" data-slide-to="1"></li>
                        <li data-target="#myCarousel" data-slide-to="2"></li>
                    </ol>
                    <!-- Wrapper for carousel items -->
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            
                            <!--item #0-->
                            <div class="d-flex text-center pt-5">
                                <div class="praise-box-text">
                                    <p>We've called Winston over for a few jobs over the last year or so, and he's genuinely great. He's done a fantastic job every time and I'm always left impressed with his professionalism, kindness and amazing customer service. I'll be continuing to call him for all my plumbing needs.</p>
                                    <br>
                                    <p class="text-end">Muhammad Haider, Edmonton</p>
                                </div>
                            </div>
                        
                        </div>
    
                        <!--item #1-->
                        <div class="carousel-item">
                            <div class="d-flex text-center pt-5">
                                <div class="praise-box-text">
                                    <p>Winston really exceeded my expectations by helping to sort out some drain issues at my home. Explained what the issue was and provided options on how to address it. Very knowledgeable and realiable. My sinks work now and super happy that its leak free.</p>
                                    <br>
                                    <p class="text-end">J de Leon, Edmonton</p>
                                </div>
                            </div>
                        </div>
    
                        <!--item #2-->
                        <div class="carousel-item">
                            <div class="d-flex text-center pt-5">
                                <div class="praise-box-text">
                                    <p>I recently had a plumbing emergency at my restaurant , and Winston came to the rescue! 🚿🔧 he was incredibly responsive and arrived right after I called him. He quickly assessed the situation and fixed the issue with precision and expertise. He  was friendly and helpful . The pricing was fair, and the service was top-notch. I highly recommend old faithful Plumbing for all your plumbing needs! They're the real deal! 👍😄</p>
                                    <br>
                                    <p class="text-end">Hamdi Ali, Edmonton</p>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="row pt-5 home-contact-bottom-btn">
        <div class="col-sm-12 d-flex justify-content-center mb-pt mb-tablet-pb">
            <button type="button" class="btn btn-red"><a routerLink="/contact" href="/contact">CONTACT US</a></button>
        </div>
    </div>
</div>
